import React from "react";

export default function NBACourt({
  lineColor,
  showChargingCircle = false,
  showKeyHashMarks = false,
}) {
  return (
    <>
      {/*SIDELINE*/}
      <rect
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        x="-25"
        y="0"
        width="50"
        height="94"
      />
      {/*BACKBOARD*/}
      <path strokeWidth="0.2" fill="none" stroke={lineColor} d="M -3 4 L 3 4" />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M -3 90 L 3 90"
      />
      {/*BASKET*/}
      <circle
        r="0.75"
        cx="0"
        cy="5.25"
        fill="none"
        strokeWidth="0.2"
        stroke={lineColor}
      />
      <circle
        r="0.75"
        cx="0"
        cy="88.75"
        fill="none"
        strokeWidth="0.2"
        stroke={lineColor}
      />
      {/*PAINTED AREA*/}
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M -8 94 L -8 75 L 8 75 L 8 94"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M -8 0 L -8 19 L 8 19 L 8 0"
      />
      {/*circle Free Throw*/}
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M -6 19 A 6 6 0 0 0 6 19"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        strokeDasharray="1,1"
        stroke={lineColor}
        d="M -6 75 A 6 6 0 0 0 6 75"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        strokeDasharray="1, 1"
        stroke={lineColor}
        d="M 6 19 A 6 6 0 0 0 -6 19"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 6 75 A 6 6 0 0 0 -6 75"
      />
      {/*Three Point Line*/}
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M -22 0 L -22 14.25"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 22 0 L 22 14.25"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M -22 94 L -22 79.75"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 22 94 L 22 79.75"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M -22 14.1977650841 A 23.75 23.75 0 0 0 22 14.1977650841"
      />
      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M 22 79.8022349159 A 23.75 23.75 0 0 0 -22 79.8022349159"
      />

      <circle
        r="6"
        cx="0"
        cy="47"
        fill="none"
        strokeWidth="0.2"
        stroke={lineColor}
      />

      {showChargingCircle && (
        <>
          <path
            strokeWidth="0.2"
            fill="none"
            stroke={lineColor}
            d="M -4 5.25  A 4 4 0 0 0 4 5.25"
          ></path>
        </>
      )}

      {showKeyHashMarks && (
        <g>
          <line
            y1="15"
            x1="-8"
            y2="15"
            x2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            y1="12"
            x1="-8"
            y2="12"
            x2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            y1="8"
            x1="-8"
            y2="8"
            x2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            y1="7"
            x1="-8"
            y2="7"
            x2="-8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            y1="15"
            x1="8"
            y2="15"
            x2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            y1="12"
            x1="8"
            y2="12"
            x2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            y1="8"
            x1="8"
            y2="8"
            x2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
          <line
            y1="7"
            x1="8"
            y2="7"
            x2="8.5"
            stroke={lineColor}
            strokeWidth="0.2"
          />
        </g>
      )}

      <path
        strokeWidth="0.2"
        fill="none"
        stroke={lineColor}
        d="M -25 47 L 25 47"
      />
    </>
  );
}
